<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="uppercase font-jost-medium text-blue-dark text-base">{{ account.chainName }} Account</h2>
    <div class="flex items-center justify-between">    
      <!-- Middle: Account Details -->
      <div class="flex-1 flex items-center gap-[50px] mr-4 min-w-0">
        <!-- Hash - Truncated -->
        <div class="flex items-center min-w-0 flex-2">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Account address:</span>
          <router-link v-if="account.value" :to="{name: 'account', params: { chainNumber: account.chainNumber, address: account.value }}"
            class="text-[#374151] font-jost-regular text-base break-all">
              {{ account.value || 'N/A' }}
          </router-link>
        </div>

        <!-- Chain name -->
        <!-- <div class="flex items-center gap-2 text-base flex-2">
          <span class="text-[#6B7280]">Chain Name:</span>
          <RouterLink :to="{ name: 'chain', params: { chainNumber: account.chainNumber } }" class="text-[#374151] font-jost-regular" :title="account.chainName || 'N/A'">
            {{ account.chainName || 'N/A' }}
          </RouterLink>
        </div> -->

        <!-- <div class="flex items-center min-w-0 flex-1">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Balance:</span>
          <span class="text-[#374151] font-jost-regular text-base" :title="account.balance">
            #{{ account.balance || '0' }}
          </span>
        </div> -->
      </div>
      
      <!-- Right Side: Value + Time -->
      <!-- <div class="flex items-center gap-4 text-base">
        <div class="text-right">
          <div class="text-[#374151] font-semibold uppercase">
            {{ account.type }} Account
          </div>
        </div>
      </div> -->
    </div>
  </li>
</template>

<script>
import {
  AccountType,
  getAccountTypeFromBase58String } from '@/utils/accountType';
import { 
  formatDateTime, 
  truncateAddress
 } from '@/helpers/common';

export default {
  name: 'AccountCard',
  props: {
    account: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
    truncateAddress(address) {
      return truncateAddress(address);
    },
  }
}
</script>

<style scoped>
.transaction-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
</style>